import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

@Component({
  selector: "jni-quarterly-support-table",
  templateUrl: "./quarterly-support-table.component.html",
  styleUrls: ["./quarterly-support-table.component.scss"],
  imports: [CommonModule],
})
export class QuarterlySupportTableComponent {}
